import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import Vue from 'vue';
import { methods } from 'lib/const';
import { applyClientMiddleware } from 'src/main';
import api from 'api/api';
import ApiClient from '../../lib/client';
import { app } from '../../main';
import store from 'store';
import { isFun } from '../../lib/utils';
import storeCache from './storeCache';

var _methods = _slicedToArray(methods, 3),
    success = _methods[0],
    failure = _methods[1],
    request = _methods[2];

var client = new ApiClient();

var VuexModule = function VuexModule(state, getters, actions, mutations, isNamespaced) {
  _classCallCheck(this, VuexModule);

  _defineProperty(this, "state", void 0);

  _defineProperty(this, "getters", void 0);

  _defineProperty(this, "actions", void 0);

  _defineProperty(this, "mutations", void 0);

  this.state = state;
  this.getters = getters;
  this.actions = actions;
  this.mutations = mutations;
  this.namespaced = isNamespaced;

  this.actions[request] = function (context, params) {
    var dispatch = context.dispatch,
        commit = context.commit,
        state = context.state;
    var type = params.type,
        apiParams = params.apiParams,
        otherConfig = params.otherConfig,
        isNamespace = params.isNamespace,
        module = params.module;
    var cache = otherConfig.cache;
    var cacheStore = storeCache["".concat(type, "_cache")];

    if (cache && cacheStore && isFun(cacheStore) && cacheStore(state)) {
      console.info('缓存请求', cacheStore);
      return;
    }

    var _api$type = api[type](apiParams),
        promise = _api$type.promise;

    if (!promise) {
      alert('错误的请求方式!!!');
      return;
    }

    commit(request);
    return new Promise(function (resolve, reject) {
      promise(client).then(function (result) {
        if (result.success !== undefined) {
          if (result.success) {
            commit(success, {
              data: result.data,
              otherConfig: otherConfig
            });
            resolve(result.data);
          } else {
            commit(failure, {
              error: result.message
            });
            reject(result.message);
          }
        } else if (result.status !== undefined) {
          if (result.status === 'true') {
            commit(success, {
              data: result.result,
              otherConfig: otherConfig
            });

            var _type = isNamespace ? module + type : type;

            store._mutations[_type] && commit(type, {
              data: result.result,
              otherConfig: otherConfig
            });
            resolve(result.result);
          } else {
            commit(failure, {
              error: result.msg
            });
            reject(result.msg);
          }
        }
      }).catch(function (error) {
        if (error.timeout) {
          var errorMsg = '网络连接超时，请重试';
          commit(failure, {
            error: errorMsg
          });
          reject(errorMsg);
        } else if (error.status) {
          var _errorMsg = '访问未授权，请重新进入';

          switch (error.status) {
            case 401:
              app.$f7.alert(_errorMsg, '友情提示');
              reject(_errorMsg);
              break;

            default:
              _errorMsg = '遭遇系统异常，请重试';
              commit(failure, {
                error: _errorMsg
              });
              reject(_errorMsg);
          }
        } else {
          var _errorMsg2 = '遭遇系统异常，请重试';
          commit(failure, {
            error: _errorMsg2
          });
          reject(_errorMsg2);
        }

        throw new Error(error);
      });
    });
  };

  this.mutations[request] = function (state) {
    var responseStateObject = {
      status: request,
      error: null,
      result: null
    };
  };

  this.mutations[failure] = function (state, _ref) {
    var params = _ref.params,
        otherConfig = _ref.otherConfig;
  };

  this.mutations[success] = function (state, _ref2) {
    var params = _ref2.params,
        data = _ref2.data,
        otherConfig = _ref2.otherConfig;
    var onSuccess = otherConfig.onSuccess;
    onSuccess && onSuccess(state, data);
  };
};

export { VuexModule as default };
export function createModule() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var getters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var actions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var mutations = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var isNamespaced = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
  return new VuexModule(state, getters, actions, mutations, isNamespaced);
}